import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import {Route, BrowserRouter} from "react-router-dom"
import Login from './Login';
import DeveloperPortal from './DeveloperPortal';
ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <Route path="/" exact render={Header}/>
        <Route path="/login" render={Login}/>
        <Route path="/developerportal" render={DeveloperPortal}/>
        <Route path="/" exact render={Home}/>
        <Footer/>
      </BrowserRouter>
    </React.StrictMode>,
  document.getElementById('root')
);
reportWebVitals();
